// Authority searchable indexes constants - matches FOLIO pattern
// Based on stripes-authority-components implementation

export const searchableIndexesValues = {
  KEYWORD: 'keyword',
  PERSONAL_NAME: 'personalName',
  CORPORATE_NAME: 'corporateName',
  MEETING_NAME: 'meetingName',
  UNIFORM_TITLE: 'uniformTitle',
  SUBJECT: 'subject',
  GEOGRAPHIC_NAME: 'geographicName',
  NAME_TITLE: 'nameTitle',
  GENRE: 'genre',
};

// Map linking search types to corresponding CQL fields for FOLIO
export const searchableIndexesMap = {
  [searchableIndexesValues.KEYWORD]: [
    {
      name: 'keyword',
      plain: true,
    },
  ],
  [searchableIndexesValues.PERSONAL_NAME]: [
    {
      name: 'personalName',
      plain: true,
      sft: true,
      saft: true,
    },
  ],
  [searchableIndexesValues.CORPORATE_NAME]: [
    {
      name: 'corporateName',
      plain: true,
      sft: true,
      saft: true,
    },
  ],
  [searchableIndexesValues.MEETING_NAME]: [
    {
      name: 'meetingName',
      plain: true,
      sft: true,
      saft: true,
    },
  ],
  [searchableIndexesValues.UNIFORM_TITLE]: [
    {
      name: 'uniformTitle',
      plain: true,
      sft: true,
      saft: true,
    },
  ],
  [searchableIndexesValues.SUBJECT]: [
    {
      name: 'topicalTerm',
      plain: true,
      sft: true,
      saft: true,
    },
  ],
  [searchableIndexesValues.GEOGRAPHIC_NAME]: [
    {
      name: 'geographicName',
      plain: true,
    },
    {
      name: 'sftGeographicName',
      sft: true,
    },
    {
      name: 'saftGeographicName',
      saft: true,
    },
  ],
  [searchableIndexesValues.NAME_TITLE]: [
    {
      name: 'personalNameTitle',
      plain: true,
      sft: true,
      saft: true,
    },
    {
      name: 'corporateNameTitle',
      plain: true,
      sft: true,
      saft: true,
    },
    {
      name: 'meetingNameTitle',
      plain: true,
      sft: true,
      saft: true,
    },
  ],
  [searchableIndexesValues.GENRE]: [
    {
      name: 'genreTerm',
      plain: true,
      sft: true,
      saft: true,
    },
  ],
};

// Function to convert authority type from current system to search index
export const getSearchIndexFromAuthorityType = (authorityType) => {
  if (!authorityType) {
    return searchableIndexesValues.KEYWORD;
  }

  // Handle searchBy (if exists) or searchType
  const searchField = authorityType.searchBy || authorityType.searchType;

  if (!searchField) {
    return searchableIndexesValues.KEYWORD;
  }

  switch (searchField) {
    case 'personalName':
      return searchableIndexesValues.PERSONAL_NAME;
    case 'corporateName':
      return searchableIndexesValues.CORPORATE_NAME;
    case 'meetingName':
      return searchableIndexesValues.MEETING_NAME;
    case 'uniformTitle':
      return searchableIndexesValues.UNIFORM_TITLE;
    case 'subject':
      return searchableIndexesValues.SUBJECT;
    case 'geographicName':
      return searchableIndexesValues.GEOGRAPHIC_NAME;
    case 'nameTitle':
      return searchableIndexesValues.NAME_TITLE;
    case 'genre':
      return searchableIndexesValues.GENRE;
    case 'all':
    default:
      return searchableIndexesValues.KEYWORD;
  }
};
